export default __webpack_public_path__ + "static/newsletter-desktop-9ee208f233eb20925a47dd5b8c9351a1.jpg";